import { HttpErrorResponse } from '@angular/common/http';

export interface BaseHttpError {
  code(): string;
  description(): string;
}

export class BaseHttpResponseError extends HttpErrorResponse implements BaseHttpError {
  constructor(err: HttpErrorResponse) {
    super(err);
  }

  public get description() {
    return this.isHttpServerError ? this.message : this.error.desc;
  }

  public get code() {
    return this.isHttpServerError ? this.status : this.error.code;
  }

  /**
   * In Miq HttpServer (Nginx) error differ from Application server errors (Beego server)
   * because status is numeric and don't provide error as object. Therefore to distinguish
   * how to return code and description we check if error object is a string (nginx html
   * response)
   */
  private get isHttpServerError() {
    return typeof this.error === 'string';
  }
}
